import { Type } from "class-transformer";
import { IsDate, ValidateNested, IsArray } from "class-validator";
import TransmedReceiving from "../receiving";

export default class TransmedAnnouncement {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TransmedReceiving)
  public readonly receivings!: TransmedReceiving[];

  @Type(() => Date)
  @IsDate()
  public readonly registration_start!: Date;

  @Type(() => Date)
  @IsDate()
  public readonly registration_end!: Date;
}
